import { useState, useEffect } from 'react'
import countries from 'i18n-iso-countries'
import { toTitleCase } from '../string'
import { useTranslation } from 'react-i18next'

export const BankLocation = ({ bankCity, bankCountryISO }) => {
	const { t, i18n } = useTranslation()
	const language = i18n.language

	const [bankLocation, setBanklocation] = useState(t('unknownBankLocation'))

	useEffect(() => {
		getBankLocation(bankCity, bankCountryISO, language).then(setBanklocation)
	}, [bankCity, bankCountryISO, language])

	return bankLocation
}

export const getBankLocation = (bankCity, bankCountryISO, language) => {
	return new Promise((resolve, reject) => {
		if (bankCity && bankCountryISO) {
			const lang = language.substring(0, 2) || 'en'
			import(`i18n-iso-countries/langs/${lang}.json`).then((locale) => {
				countries.registerLocale(locale)

				let city = bankCity.split(',')
				city[0] = toTitleCase(city[0])

				const country = countries.getName(bankCountryISO, lang)

				resolve(`${city.join(', ')}, ${country}`)
			})
		}
	})
}
